import React, { useState, useEffect, useRef } from 'react';
import Swal from "sweetalert2";
import api from '../../../services/axios';
import { useJWTAuth } from '../../../services/JWTAuthProvider';
import { Modal, ModalBody, ModalFooter, ModalHeader } from "../../common/modal/index";
import config from '../../../config';
import { userRole } from '../../../constants/appConst';

export const BulkUserUploadModal = ({ isOpen, closeCallback }) => {
    const { user } = useJWTAuth();
    var xlsx = require("xlsx")
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFolders, setSelectedFolders] = useState([]);
    const [selectAllCbx, setselectAllCbx] = useState(false);
    const [subBtnDisabled, setSubBtnDisabled] = useState(false);
    const fileRef = useRef();

    useEffect(() => {
        setSelectedFile(null);
        fileRef.current.value = null;
        setSelectedFolders([]);
        setselectAllCbx(false);
        setSubBtnDisabled(false)
    }, [isOpen]);

    const limitFileNameLength = (fileName, maxLength) => {
        if (fileName !== undefined) {
            if (fileName.length <= maxLength) {
                return fileName;
            } else {
                const fileNameWithoutExtension = fileName.slice(0, fileName.lastIndexOf('.'));
                const truncatedFileName = fileNameWithoutExtension.slice(0, maxLength - 3);
                return truncatedFileName + '...' + fileName.slice(fileName.lastIndexOf('.'));
            }
        }

    };

    const [folderList, setFolderList] = React.useState([]);
    React.useEffect(() => {
        const getData = async () => {
            try {
                const { data } = await api.get("/Folders/getrootfolders?Id=" + user.id);
                if (data.statusCode === 200) {
                    setFolderList(data.result.folders);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        getData();
    }, []);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setSelectedFile(file);
    };

    const uploadHandler = async () => {

        const isValidName = (name) => {
            const regex = /^[a-zA-Z0-9' ]+$/;
            return regex.test(name);
        }

        const isValidUserID = (name) => {
            // Regular expression for email validation
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            // Regular expression for proper name validation
            const nameRegex = /^[a-zA-Z0-9_` ]+$/;

            // Check if the name matches either email or proper name format
            return emailRegex.test(name) || nameRegex.test(name);
        }

        // Example email validation function
        const isValidEmail = (email) => {
            // Add your email validation logic here
            // Return true if the email is valid, false otherwise
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        };

        const validatePassword = (password) => {
            const isLengthValid = password.length >= 8 && password.length <= 16;
            const hasSpecialCharacter = /[!@#$%^&*()_+{}[\]:;<>,.?~\\-]/.test(password);
            const hasCapitalLetter = /[A-Z]/.test(password);
            const hasLowerLetter = /[a-z]/.test(password);
            return isLengthValid && hasSpecialCharacter && hasCapitalLetter && hasLowerLetter;
        };
        if (selectedFile == null) {
            Swal.fire({
                position: "center",
                icon: "info",
                text: "Please select the user Excel file",
                showConfirmButton: true,
                timer: 2000,
                timerProgressbar: true
            });
            return false;
        }

        if (!selectedFile.name.includes('.xlsx')) {
            Swal.fire({
                position: "center",
                icon: "info",
                text: "Selected file is not an excel file",
                showConfirmButton: true,
                timer: 2000,
                timerProgressbar: true
            });
            return false;
        }

        setSubBtnDisabled(true)
        const arrayBuffer = await selectedFile.arrayBuffer();
        const uint8Array = new Uint8Array(arrayBuffer);
        const workbook = xlsx.read(uint8Array, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        let jsonData = xlsx.utils.sheet_to_json(worksheet);
        let notFoundUnits = '';
        const folderMapping = new Map(folderList.map(item => [item.name, item.folderIdentifier]));
        let businessUnits
        let Uniterrors = [];
        jsonData.forEach((data, index) => {

            if (data.BusinessUnit !== undefined && data.Role !== "GlobalAdmin") {
                // Split BusinessUnit into an array of business units
                businessUnits = data.BusinessUnit.split(',');

                // Check if any business unit is not in folderNames
                notFoundUnits = businessUnits.filter(unit => !folderMapping.has(unit.trim()));


                if (notFoundUnits.length > 0) {
                    Uniterrors.push(`BusinessUnit is not valid in  row number ${index + 1}`);
                } else {
                    // Business units are in folderList
                    // Add your logic here
                    console.log(`${data.BusinessUnit} is in folderList for entry ${index}`);
                }
            }
            else if (data.BusinessUnit === undefined && data.Role !== "GlobalAdmin") {

                Uniterrors.push(`BusinessUnit is required in row number ${index + 1}`);
                const errorList = Uniterrors.map((error) => `<li>${error}</li>`).join('');

                Swal.fire({
                    position: "center",
                    icon: "error",
                    text: Uniterrors,
                    html: `<ul style="list-style-type:none; padding: 0;">${errorList}</ul>`,
                    showConfirmButton: true,
                    timer: 5000,
                    timerProgressbar: true
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        try {
                            closeCallback();
                            setSelectedFile(null);
                            setSelectedFolders([]);
                            //window.location.reload();
                        } catch (error) {
                            console.error('Error fetching data:', error);
                        }
                    }
                })
                closeCallback();
                setSelectedFile(null);
                setSelectedFolders([]);
                return;
            }
            else if (data.BusinessUnit && data.Role === "GlobalAdmin") {
                businessUnits = [];
            }
            else {
                businessUnits = [];
            }
        });

        if (Uniterrors.length > 0) {

            const errorList = Uniterrors.map((error) => `<li>${error}</li>`).join('');

            Swal.fire({
                position: "center",
                icon: "error",
                text: Uniterrors,
                html: `<ul style="list-style-type:none; padding: 0;">${errorList}</ul>`,
                showConfirmButton: true,
                timer: 5000,
                timerProgressbar: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        closeCallback();
                        setSelectedFile(null);
                        setSelectedFolders([]);
                        //window.location.reload();
                    } catch (error) {
                        console.error('Error fetching data:', error);
                    }
                }
            })
            return;
        }

        if (jsonData.length === 0) {
            Swal.fire({
                position: "center",
                icon: "info",
                text: "Please upload valid Excel",
                showConfirmButton: true,
                timer: 2000,
                timerProgressbar: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        closeCallback();
                        setSelectedFile(null);
                        setSelectedFolders([]);
                        setSubBtnDisabled(false)
                        //setTimeout(() => {
                        //    //window.location.reload();
                        //}, 2000);
                    } catch (error) {
                        console.error('Error fetching data:', error);
                    }
                }
            })
            setTimeout(() => {
                closeCallback();
                setSelectedFile(null);
                setSelectedFolders([]);
                setSubBtnDisabled(false)
                //window.location.reload();
            }, 2000);
        }
        else {
            jsonData = jsonData.map((e, index) => {
                // businessUnits = e.BusinessUnit.split(',');
                // if (businessUnits && e.Role != "GlobalAdmin") {
                //     e.folders = businessUnits.map(unit => folderMapping.get(unit.trim()));
                // }
                // else {
                //     e.folders = [];
                // }
                businessUnits = e.BusinessUnit ? e.BusinessUnit.split(',') : [];

                if (businessUnits && e.Role !== "GlobalAdmin") {

                    const roleMap = {
                        "BusinessUnitAdmin": 2,
                        "BusinessUnitUser": 3,
                        "BusinessUnitUserAdministrator": 4
                    };

                    e.folderRoles = businessUnits.map(unit => ({
                        folderId: folderMapping.get(unit.trim()),
                        role: roleMap[e.Role]
                    }));

                    e.isGlobalAdmin = false;
                }
                else {

                    e.folderRoles = [];
                    e.isGlobalAdmin = true;
                }
                e.rowValue = index + 1;
                if (!e.UserID) {
                    Swal.fire({
                        position: "center",
                        icon: "info",
                        text: "User Id is requires in row number " + e.rowValue,
                        showConfirmButton: true,
                        timer: 2000,
                        timerProgressbar: true
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            try {
                                closeCallback();
                                setSelectedFile(null);
                                setSelectedFolders([]);
                                return;
                                //window.location.reload();
                            } catch (error) {
                                console.error('Error fetching data:', error);
                            }
                        }
                    })
                }
                else {
                    e.isSSOLogin = config.SSODOMAIN.findIndex((val) => e.UserID.toLowerCase().includes(val)) >= 0;
                }

                e.rowValue = index + 1; // Add 1 to make the index 1-based instead of 0-based
                if (isValidEmail(e.UserID)) {
                    e.Email = e.UserID;
                }
                else {
                    e.Email = '';
                }
                return e; // Return the modified object
            });

            //             const getCurrentUserRole = () => {

            //     if (user?.isGlobalAdmin)
            //         return userRole.GlobalAdmin;

            //     if (!user?.folders?.length)
            //         return 0;

            //     return user.folders.reduce(
            //         (highest, folder) =>
            //             folder.role < highest ? folder.role : highest,
            //         userRole.BusinessUnitUser
            //     );
            // };
            const getCurrentUserRole = () => {

                if (user?.isGlobalAdmin)
                    return userRole.GlobalAdmin;

                if (!user?.folders?.length)
                    return 0;

                return Math.min(...user.folders.map(f => f.role));
            };

            const validateData = (jsonData) => {
                const currentUserRole = getCurrentUserRole();
                const currentFolderRoles = {};

                user.folders.forEach(folder => {
                    currentFolderRoles[
                        folder.folderIdentifier.toLowerCase()
                    ] = folder.role;
                });


                const errors = [];
                jsonData.forEach((row, rowIndex) => {
                    if (currentUserRole === userRole.BusinessUnitAdmin) {
                        if (row.UserID && row.Role) {
                            if (row.Role === "GlobalAdmin") {
                                errors.push(`BusinessUnitAdmin can't upload GloblaAdmin in row number ${rowIndex + 1}`);
                            }
                        }
                    }
                    else if (currentUserRole === userRole.BusinessUnitUserAdministrator) {
                        if (row.UserID && row.Role) {
                            if (row.Role === "GlobalAdmin") {
                                errors.push(`BusinessUnitUserAdministrator can't upload GloblaAdmin in row number ${rowIndex + 1}`);
                            }
                            else if (row.Role === "BusinessUnitAdmin") {
                                errors.push(`BusinessUnitUserAdministrator can't upload BusinessUnitAdmin in row number ${rowIndex + 1}`);
                            }
                        }
                    }

                    if (row.folderRoles) {

                        row.folderRoles.forEach(folder => {

                            const creatorRole =
                                currentFolderRoles[
                                folder.folderId.toLowerCase()
                                ];

                            if (creatorRole === undefined) {

                                errors.push(
                                    `You don't have access to Business Unit in row ${rowIndex + 1}`
                                );

                            }
                            else if (folder.role < creatorRole) {

                                errors.push(
                                    `Cannot assign higher role for Business Unit in row ${rowIndex + 1}`
                                );

                            }

                        });

                    }

                    if (row.Name === undefined) {
                        errors.push(`Name is required in row number ${rowIndex + 1}`);
                    }
                    else if (!isValidName(row.Name)) {
                        errors.push(`Invalid Name format in row number ${rowIndex + 1}`);
                    }


                    // Validate each column in the row
                    if (row.UserID === undefined) {
                        errors.push(` UserID is required in row number ${rowIndex + 1}`);
                    }

                    if (config.SSODOMAIN.findIndex((val) => row.UserID.includes(val)) >= 0) {
                        if (!isValidEmail(row.UserID)) {
                            errors.push(` Invalid email format in row number ${rowIndex + 1}`);
                        }

                    }
                    else if (!isValidUserID(row.UserID)) {
                        errors.push(`Invalid User ID format in row number ${rowIndex + 1}`);
                    }

                    if (row.Password == undefined) {
                        errors.push(`Password is required in row number ${rowIndex + 1}`);
                    }
                    else if (!validatePassword(row.Password)) {
                        errors.push(`Invalid password in row number ${rowIndex + 1}`);
                    }

                    if (!row.Role) {
                        errors.push(`Role is required in row number ${rowIndex + 1}`);

                    }
                    else {
                        if (row.Role !== "GlobalAdmin") {
                            if (row.Role !== "BusinessUnitAdmin") {
                                if (row.Role !== "BusinessUnitUser") {
                                    if (row.Role !== "BusinessUnitUserAdministrator") {
                                        errors.push(`Invalid Role in row number ${rowIndex + 1}`);
                                    }
                                }
                            }
                        }
                    }
                });

                return errors;
            };

            // ...

            // Before sending data to the API, perform validation
            const validationErrors = validateData(jsonData);

            if (validationErrors.length > 0) {
                const errorList = validationErrors.map((error) => `<li>${error}</li>`).join('');

                // Handle validation errors (e.g., show error messages, prevent API call)
                Swal.fire({
                    position: "center",
                    icon: "error",
                    text: validationErrors,
                    html: `<ul style="list-style-type:none; padding: 0;">${errorList}</ul>`,
                    showConfirmButton: true,
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        try {
                            closeCallback();
                            setSelectedFile(null);
                            setSelectedFolders([]);
                            //window.location.reload();
                        } catch (error) {
                            console.error('Error fetching data:', error);
                        }
                    }
                })

            } else {
                // Proceed with API call
                try {
                    debugger;
                    const { data } = await api.post('/UserCreation/BulkInsertUsersExcel', {
                        commands: jsonData,
                    });
                    console.log(JSON.stringify(jsonData, null, 2));
                    // if (data.statusCode === 200) {
                    //     Swal.fire({
                    //         position: "center",
                    //         icon: "success",
                    //         text: "Users upload done Successfully",
                    //         showConfirmButton: true,
                    //         timer: 2000,
                    //         timerProgressbar: true
                    //     }).then(async (result) => {
                    //         if (result.isConfirmed) {
                    //             try {
                    //                 closeCallback();
                    //                 setSelectedFile(null);
                    //                 setSelectedFolders([]);
                    //             } catch (error) {
                    //                 console.error('Error fetching data:', error);
                    //             }
                    //         }
                    //     })
                    //     closeCallback();
                    //     setSelectedFile(null);
                    //     setSelectedFolders([]);
                    // }
                    if (data.statusCode === 200) {

                        const summary = data.result;

                        let errorHtml = "";

if (summary.errors?.length > 0) {

    errorHtml = `
    <div style="
        margin-top:20px;
        border-top:1px solid #ddd;
        padding-top:15px;
    ">

        <div style="
            font-size:17px;
            font-weight:600;
            margin-bottom:10px;
        ">
            Skipped Rows
        </div>

        <div style="
            max-height:220px;
            overflow-y:auto;
            text-align:left;
            border:1px solid #e5e5e5;
            border-radius:6px;
            padding:10px;
            background:#fafafa;
        ">

            ${summary.errors.map(x => `
                <div style="
                    padding:8px;
                    margin-bottom:8px;
                    background:white;
                    border-left:4px solid #dc3545;
                    border-radius:4px;
                ">
                    ${x}
                </div>
            `).join("")}

        </div>

    </div>`;
}

                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Bulk Upload Completed",
                            html: `
<div style="padding:10px">

    <div style="
        display:flex;
        justify-content:center;
        gap:20px;
        font-size:17px;
        font-weight:600;
        margin-bottom:20px;
    ">

        <span style="color:#28a745">
            Created -  ${summary.created}
        </span>

        <span>|</span>

        <span style="color:#ff9800">
            Updated -  ${summary.updated}
        </span>

        <span>|</span>

        <span style="color:#dc3545">
            Skipped -  ${summary.skipped}
        </span>

    </div>

    ${errorHtml}

</div>
`,
                            showConfirmButton: true
                        }).then(() => {
                            closeCallback();
                            setSelectedFile(null);
                            setSelectedFolders([]);
                        });
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            }


            setSubBtnDisabled(false)
        }


    };

    return (
        <Modal isLarge={false} isOpen={isOpen}>
            <ModalHeader>
                <h5 className="modal-title"> <img src='/Assets/upload.svg' alt='Upload users' /> Upload users from excel</h5>
            </ModalHeader>
            <ModalBody>

                <div className="upload-box">
                    <label htmlFor="myfile" className="custom-file-label">
                        {selectedFile != null
                            ? limitFileNameLength(selectedFile.name, 25)
                            : "Click 'Choose File' to upload file(s)"}
                    </label>
                    <input
                        ref={fileRef}
                        type="file"
                        id="myfile"
                        name="myfile"
                        className="file-input"
                        onChange={handleFileChange}
                    />
                </div>
            </ModalBody>
            <ModalFooter>
                <button type="button" className="btn btn-secondary" onClick={closeCallback}>Cancel</button>
                <button type="button" disabled={subBtnDisabled} className="btn btn-primary" onClick={uploadHandler}>Upload</button>
            </ModalFooter>
        </Modal>
    )
}
